import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const useGenerateBIN = (
  isLoading,
  hasBIN,
  isStartAssessment,
  transactionStatus,
  isValidated,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isStatusAllowed = ['FOR CHECKING'].indexOf(transactionStatus) > -1;

  const isAllowed = true && isStatusAllowed;

  const showComponent =
    isAllowed && isStartAssessment && !hasBIN && isValidated;

  const onHandleClick = (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want generate BIN for this application?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const component = showComponent ? (
    <button
      disabled={isLoading}
      onClick={onHandleClick}
      type="button"
      className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
    >
      {isLoading && (
        <>
          <i className="fas fa-spinner fa-spin" />
          &nbsp;
        </>
      )}
      Generate BIN
    </button>
  ) : null;

  return {
    isAllowed,
    onHandleClick,
    component,
  };
};

export default useGenerateBIN;
